import { startLoginWithApple } from "actions/authFunctions"
import LoginButton from "components/utils/loginButtons/LoginButton"
import appleIcon from "images/login/apple.svg"

const AppleLoginButton = () => {
  return <LoginButton icon={appleIcon} text="Mit Apple anmelden" onClick={startLoginWithApple} />
}

export default AppleLoginButton
